import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LocalizedDateFormatPipe } from '@wilson/localization';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DateFnsModule } from 'ngx-date-fns';
import { OnClickRendererParams } from './confirmed-by-user-renderer';

@Component({
  selector: 'wilson-qualifications-v2-acquired-on-date-renderer',
  template: `
    <div class="cursor-pointer" (click)="onClick($event)">
      {{ cellValue ? (cellValue | dfnsParseIso | localizedDateFormat) : '---' }}
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DateFnsModule, LocalizedDateFormatPipe],
})
export class DateRendererComponent implements AgRendererComponent {
  public cellValue!: string;
  params!: OnClickRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.cellValue = this.getValueToDisplay(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.cellValue = this.getValueToDisplay(params);
    return true;
  }

  getValueToDisplay(params: ICellRendererParams): string {
    return params.value;
  }

  onClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.params?.onClick) {
      this.params.onClick(event, this.params.data);
    }
  }
}
